// 振替授業一覧（/admin/make-up-lessons）の備考欄
// - 備考セルの省略テキストを hover したときの popover による全文表示
// - 行ごとの備考編集モーダルの開閉と対象行の値のセット

const MODAL_ID = 'make-up-lesson-remarks-modal'
const ACTION_PLACEHOLDER = '__ONLINE_LESSON_ATTENDANCE_ID__'

/**
 * popover を呼び出し要素の直下に表示する
 *
 * Popover API の既定位置はビューポート中央のため、対象セルの位置に合わせて座標を設定する
 *
 * @param {HTMLElement} trigger
 * @param {HTMLElement} popover
 * @returns {void}
 */
const showPopoverNearTrigger = (trigger, popover) => {
    const rect = trigger.getBoundingClientRect()
    popover.style.position = 'fixed'
    popover.style.margin = '0'
    popover.style.top = `${rect.bottom + 4}px`
    popover.style.left = `${rect.left}px`

    popover.showPopover()
}

/**
 * hover / focus で全文 popover を表示する挙動を設定する
 *
 * @returns {void}
 */
const setUpRemarksPopovers = () => {
    document.querySelectorAll('.js-remarks-preview').forEach((trigger) => {
        const popover = document.getElementById(trigger.getAttribute('popovertarget'))
        if (!popover) {
            return
        }

        // Popover API 非対応ブラウザでは title 属性による全文表示にフォールバックする
        if (typeof popover.showPopover !== 'function') {
            trigger.title = popover.textContent
            return
        }

        trigger.addEventListener('mouseenter', () => showPopoverNearTrigger(trigger, popover))
        trigger.addEventListener('focus', () => showPopoverNearTrigger(trigger, popover))
        trigger.addEventListener('mouseleave', () => popover.hidePopover())
        trigger.addEventListener('blur', () => popover.hidePopover())
    })
}

/**
 * 備考編集モーダルの開閉と対象行の値のセットを設定する
 *
 * @returns {void}
 */
const setUpRemarksModal = () => {
    const modal = document.getElementById(MODAL_ID)
    if (!modal) {
        return
    }

    const form = document.getElementById('make-up-lesson-remarks-form')
    const textarea = document.getElementById('make-up-lesson-remarks-textarea')
    const absenceIdInput = document.getElementById('make-up-lesson-remarks-absence-id')
    const target = document.getElementById('make-up-lesson-remarks-modal-target')
    const actionTemplate = modal.dataset.actionTemplate || ''

    const closeModal = () => {
        modal.classList.add('hidden')
        modal.classList.remove('flex')
    }

    const openModal = (button) => {
        form.action = actionTemplate.replace(ACTION_PLACEHOLDER, button.dataset.absenceId)
        absenceIdInput.value = button.dataset.absenceId
        textarea.value = button.dataset.remarks || ''
        target.textContent = `欠席者: ${button.dataset.absentUserName || ''}`

        modal.classList.remove('hidden')
        modal.classList.add('flex')
        textarea.focus()
    }

    document.querySelectorAll('.js-remarks-edit-button').forEach((button) => {
        button.addEventListener('click', () => openModal(button))
    })

    modal.querySelectorAll('.js-remarks-modal-close').forEach((button) => {
        button.addEventListener('click', closeModal)
    })

    // 背景（オーバーレイ）のクリックで閉じる
    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            closeModal()
        }
    })

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeModal()
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    setUpRemarksPopovers()
    setUpRemarksModal()
})
